import { render, staticRenderFns } from "./confirmarDados.vue?vue&type=template&id=6348de99&"
import script from "./confirmarDados.vue?vue&type=script&lang=js&"
export * from "./confirmarDados.vue?vue&type=script&lang=js&"
import style0 from "./confirmarDados.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports